export const roundUp = (number: number) => Math.ceil(number);
